import React, { ReactElement } from 'react'
import { Flex } from 'theme-ui'
import { TitleSection as Title } from '../NewStaticPage'
import { CONTROLDText } from 'ui/CONTROLD'
import useBreakpointIndex from 'ui/Theme/useBreakpointIndex'

export function StatusPageTitle({
  shouldShowErrorBox,
}: {
  shouldShowErrorBox: boolean
}): ReactElement {
  const isMobile = useBreakpointIndex() === 0
  return (
    <Flex
      sx={{
        width: ['100%', '67.2rem', '100rem'],
        gap: ['3.2rem', '4.8rem'],
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <Title
        subTitle={
          !isMobile
            ? 'Your one stop shop for all troubleshooting efforts. Click the Copy results button, and paste the results for Support to take a closer look.'
            : undefined
        }
        sxSubTitle={{
          maxWidth: '78rem',
        }}
        sxTitle={{
          fontSize: ['3.2rem', '5.2rem'],
        }}
        shouldShowErrorBox={shouldShowErrorBox}
      >
        {isMobile ? `Configuration Status` : `${CONTROLDText} Configuration Status`}
      </Title>
    </Flex>
  )
}
